import { TemplatesReducerCreator } from '../types';

const clearTemplatesListReducer = (create: TemplatesReducerCreator) => {
  return create.reducer((state) => {
    state.templates = [];
    state.totalTemplates = null;
    state.templatesListPage = 1;
  });
};
export default clearTemplatesListReducer;
